import './index.scss';
import 'react-datepicker/dist/react-datepicker.css';
import React, { Component } from 'react';
import DatePicker from 'react-date-picker';
import LabeledDateWithRangePicker from './LabeledDateWithRangePicker';
import PropTypes from 'prop-types';

class LabeledDateRangePicker extends Component {

    state = {
        showRange: true,
    }

    handleDateChange = ( props, name, date ) => {

        this.props.onChange( props, name, date );

    }

    toggle = () => {

        this.setState( {
            showRange: !this.state.showRange,
        } );

    }

    render () {

        return (
            <div className="date-range-picker">
                <label>
                    {this.props.label}
                    <span className={`asterisk-icon ${this.props.isRequired ? 'mandatory' : ''}`}>
                        <i className="fa fa-asterisk" />
                    </span>
                </label>
                <div className={`serach-range ${!this.state.showRange ? 'show' : ''}`}>
                    <DatePicker
                        className={this.props.className}
                        value={this.props.from}
                        onChange={this.handleDateChange.bind( this, this.props, 'buildDate' )}
                        name={this.props.name}
                        maxDate={new Date()}
                        dayPlaceholder="DD"
                        monthPlaceholder="MM"
                        yearPlaceholder="YYYY"
                        format={this.props.dateFormat}
                    />

                </div>
                <div>
                    <div className={`serach-range ${this.state.showRange ? 'show' : ''}`}>
                        <LabeledDateWithRangePicker
                            className={this.props.className}
                            selectedFrom={this.props.from}
                            selectedTo={this.props.to}
                            handleDateChange={this.handleDateChange.bind( this )}
                            name={this.props.name}
                            dateFormat={this.props.dateFormat}
                        />
                    </div>
                    <label className="serach-range-label" onClick={this.toggle}>
                        <i className={`arrow-icon fa ${!this.state.showRange ? 'fa-angle-down' : 'fa-angle-up'}`} />
                                        Search Range

                    </label>
                </div>

            </div>
        );

    }

}
LabeledDateRangePicker.displayName = 'LabeledDateRangePicker';
LabeledDateRangePicker.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    to: PropTypes.number.isRequired,
    from: PropTypes.number.isRequired,
    className: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    dateFormat: PropTypes.string,
};

export default LabeledDateRangePicker;
